import React from "react";
import arrowLeft from "../../assets/images/icons/ic_arrow_left.svg";
import arrowNorthEast from "../../assets/images/icons/ic_arrow_northeast.svg";
import * as Styled from "./Style";

const ContinueShopping = (props) => {
  return (
    <Styled.ContinueShoppingStyle>
      <a href={props.path}>
        <img
          // src={arrowLeft}
          src={`${arrowLeft}`}
          alt=""
        />{" "}
        Continue shopping
      </a>
      {props.page == "bag" ? (
        <a href="/shopping-help" style={{ float: "right" }} target="_blank">
          Shopping help <img src={`${arrowNorthEast}`} alt="" />
        </a>
      ) : (
        ""
      )}
    </Styled.ContinueShoppingStyle>
  );
};
export default ContinueShopping;
